import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { profile } from '../data/profile';
import { sections } from '../data/sections';
export function SiteFooter() {
  return <footer className="border-t border-white/10 bg-navy-950 py-14" aria-label="Site footer" data-id="element-87" data-mp="3mfydg5o9j7nv">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-12 px-6 lg:grid-cols-12 lg:px-10" data-id="element-88" data-mp="3hhoinw6ga92s">
        <div className="lg:col-span-5" data-id="element-89" data-mp="3difq2un5ch8t">
          <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white" data-id="element-90" data-mp="38hrpbh948m1e">
            {profile.name}
          </p>
          <p className="mt-4 max-w-sm font-sans text-sm leading-relaxed text-platinum-300" data-id="element-91" data-mp="33jq52szyegoc">
            {profile.title}
          </p>
          <ul className="mt-6 space-y-2.5" data-id="element-92" data-mp="2yleuuh5qy45l">
            <li className="flex items-center gap-3" data-id="element-93" data-mp="11rtw9r567kx9">
              <MailIcon className="h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-94" data-mp="11qiq5ko9612z" />
              <a href={`mailto:${profile.email}`} className="font-sans text-sm text-platinum-200 transition-colors duration-150 ease-out hover:text-gold-400" data-id="element-95" data-mp="wsqo3xtw8yl2">
                {profile.email}
              </a>
            </li>
            <li className="flex items-center gap-3" data-id="element-96" data-mp="vth13qxan6zk">
              <PhoneIcon className="h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-97" data-mp="vv213w2dni4t" />
              <a href={`tel:${profile.phone.replace(/\s/g, '')}`} className="font-sans text-sm text-platinum-200 transition-colors duration-150 ease-out hover:text-gold-400" data-id="element-98" data-mp="10tv3otg4loq7">
                {profile.phone}
              </a>
            </li>
            <li className="flex items-center gap-3" data-id="element-99" data-mp="1er9w871oecme">
              <MapPinIcon className="h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-100" data-mp="1jq4rw9kqrvnx" />
              <span className="font-sans text-sm text-platinum-200" data-id="element-101" data-mp="27gh25r3gm4ho">{profile.location}</span>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-7" data-id="element-102" data-mp="2c7pf2x4007zl">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-platinum-300" data-id="element-103" data-mp="2c8s2gv243sar">
            All sections
          </p>
          <ul className="mt-5 grid grid-cols-1 gap-x-8 gap-y-2.5 sm:grid-cols-2" data-id="element-104" data-mp="2h4w6vjfwfj2z">
            {sections.map(section => <li key={section.path} data-id="element-105" data-mp="2d0eo9nl9zbts">
                <Link to={section.path} className="flex items-baseline gap-3 font-sans text-sm text-platinum-200 transition-colors duration-150 ease-out hover:text-gold-400" data-id="element-106" data-mp="283euab1p9zj1">
                  <span className="font-display text-xs font-bold text-gold-500" data-id="element-107" data-mp="1ycafpcfxsgoq">{section.number}</span>
                  <span data-id="element-108" data-mp="1tfa7auvm71ug">{section.name}</span>
                </Link>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-12 w-full max-w-7xl border-t border-white/10 px-6 pt-8 lg:px-10" data-id="element-109" data-mp="1pake5dscc1d8">
        <p className="font-sans text-xs text-platinum-300" data-id="element-110" data-mp="1kfn4c4n8lnza">
          Analytics, Data &amp; AI Governance · Melbourne, Victoria
        </p>
      </div>
    </footer>;
}